import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  StatusCode,
  StatusCodeResponse,
  StatusCodeSingleResponse
} from 'Interfaces/ReferenceInterfaces/StatusCodesInterface';

export const statusCodesScreenServices = {
  getAllStatusCodes: (page = 1, pageSize = 10000): Promise<StatusCodeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<StatusCodeResponse>(
          `pps/status-codes?page=${page}&page_size=${pageSize}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getStatusCodeById: (id: number): Promise<StatusCodeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<StatusCodeSingleResponse>(`pps/status-codes/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createStatusCode: (statusCodeData: Partial<StatusCode>): Promise<StatusCodeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<StatusCodeSingleResponse>(
          'pps/status-codes/',
          statusCodeData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateStatusCode: (
    id: number,
    statusCodeData: Partial<StatusCode>
  ): Promise<StatusCodeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<StatusCodeSingleResponse>(
          `pps/status-codes/${id}/`,
          statusCodeData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteStatusCode: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/status-codes/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
